module.exports = {
    test: {
        title: '多语种切换测试',
        btnTextOne: '中文',
        btnTextTwo: '英文',
        btnTextThree: '韩文',
        content: '与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。',
    }
}